module.exports = __webpack_public_path__ + "img/products4.4b81c96a.svg";